
const FrutexTheme = {
  init() {
    this.initStickyHeader();
    this.initScrollAnimations();
  },
  initStickyHeader() {
    const header = document.getElementById('SiteHeader');
    if (!header) return;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 40) {
        header.classList.add('is-compact');
      } else {
        header.classList.remove('is-compact');
      }
    }, { passive: true });
  },
  toggleMobileNav() {
    const drawer = document.getElementById('MobileNavDrawer');
    if (!drawer) return;
    const isOpen = drawer.classList.toggle('is-open');
    drawer.setAttribute('aria-hidden', (!isOpen).toString());
    document.body.style.overflow = isOpen ? 'hidden' : '';
    document.documentElement.style.overflow = isOpen ? 'hidden' : '';
  },
  toggleSearch() {
    const modal = document.getElementById('SearchModal');
    if (!modal) return;
    const isOpen = modal.classList.toggle('is-open');
    modal.setAttribute('aria-hidden', (!isOpen).toString());
    if (isOpen) {
      const input = modal.querySelector('input');
      if (input) input.focus();
    }
  },
  toggleFaq(btn) {
    const item = btn.closest('.faq-accordion-item');
    const content = item.querySelector('.faq-accordion-content');
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    const parentList = item.closest('.faq-accordion-list');
    if (parentList) {
      parentList.querySelectorAll('.faq-accordion-item').forEach(otherItem => {
        if (otherItem !== item) {
          const otherBtn = otherItem.querySelector('.faq-accordion-header');
          const otherContent = otherItem.querySelector('.faq-accordion-content');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          if (otherContent) {
            otherContent.style.maxHeight = null;
            otherContent.style.paddingTop = null;
          }
        }
      });
    }
    if (isExpanded) {
      btn.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = null;
      content.style.paddingTop = null;
    } else {
      btn.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 30 + 'px';
      content.style.paddingTop = '15px';
    }
  },
  initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.why-card, .ingredient-card, .step-card, .testimonial-card').forEach(el => {
      observer.observe(el);
    });
  }
};
const FrutexHeroSlider = {
  sliders: {},
  init() {
    document.querySelectorAll('.hero-slider-section').forEach(section => {
      const id = section.dataset.sectionId;
      const autoplay = section.dataset.autoplay === 'true';
      const speed = parseInt(section.dataset.autoplaySpeed, 10) || 6000;
      const slides = section.querySelectorAll('.hero-slide');
      const dots = section.querySelectorAll('.hero-dot');
      if (slides.length <= 1) return;
      this.sliders[id] = {
        currentIndex: 0,
        total: slides.length,
        slides,
        dots,
        speed,
        autoplay,
        timer: null
      };
      if (autoplay) {
        this.startAutoplay(id);
      }
      let touchStartX = 0;
      let touchEndX = 0;
      section.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      section.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 50) {
          this.next(id);
        } else if (touchEndX - touchStartX > 50) {
          this.prev(id);
        }
      }, { passive: true });
    });
  },
  startAutoplay(id) {
    const s = this.sliders[id];
    if (!s) return;
    clearInterval(s.timer);
    s.timer = setInterval(() => {
      this.next(id);
    }, s.speed);
  },
  goTo(id, index) {
    const s = this.sliders[id];
    if (!s) return;
    s.slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });
    s.dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
    s.currentIndex = index;
    if (s.autoplay) {
      this.startAutoplay(id);
    }
  },
  next(id) {
    const s = this.sliders[id];
    if (!s) return;
    const nextIndex = (s.currentIndex + 1) % s.total;
    this.goTo(id, nextIndex);
  },
  prev(id) {
    const s = this.sliders[id];
    if (!s) return;
    const prevIndex = (s.currentIndex - 1 + s.total) % s.total;
    this.goTo(id, prevIndex);
  }
};
const FrutexCart = {
  cartData: {
    item_count: 0,
    total_price: 0,
    items: []
  },
  open() {
    const drawer = document.getElementById('FrutexCartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (window.Shopify && Shopify.routes) {
      this.fetchShopifyCart();
    } else {
      this.render();
    }
  },
  close() {
    const drawer = document.getElementById('FrutexCartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },
  addItem(variantId, quantity = 1, triggerButton = null) {
    const qty = Math.max(1, parseInt(quantity, 10) || 1);
    const originalLabel = triggerButton?.querySelector('[data-add-label]')?.textContent || triggerButton?.textContent || 'ADD TO CART';
    if (triggerButton) {
      triggerButton.classList.add('is-loading');
      triggerButton.disabled = true;
      const label = triggerButton.querySelector('[data-add-label]');
      if (label) label.textContent = 'ADDING…';
    }
    const finishButton = (success) => {
      if (!triggerButton) return;
      triggerButton.classList.remove('is-loading');
      triggerButton.disabled = false;
      const label = triggerButton.querySelector('[data-add-label]');
      if (label) label.textContent = success ? 'ADDED TO CART' : originalLabel;
      if (success) {
        triggerButton.classList.add('is-added');
        window.setTimeout(() => {
          triggerButton.classList.remove('is-added');
          if (label) label.textContent = originalLabel;
        }, 1600);
      }
    };
    if (window.Shopify && Shopify.routes) {
      return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
      .then(res => {
        if (!res.ok) throw new Error(`Cart add failed: ${res.status}`);
        return res.json();
      })
      .then(() => {
        finishButton(true);
        this.fetchShopifyCart();
      })
      .catch(err => {
        finishButton(false);
        console.error('Cart add error:', err);
      });
    } else {
      const existing = this.cartData.items.find(i => i.id === variantId);
      if (existing) {
        existing.quantity += qty;
        existing.final_line_price = existing.quantity * (existing.id === 2 ? 4999 : 2999);
      } else {
        this.cartData.items.push({
          key: 'frutex-' + variantId,
          id: variantId,
          title: 'FRUTEX Botanical Hair Oil',
          variant_title: variantId === 2 ? '200ml Duo Ritual' : '100ml Standard',
          quantity: qty,
          final_line_price: qty * (variantId === 2 ? 4999 : 2999),
          image: 'frutex-logo.png'
        });
      }
      this.recalculate();
      finishButton(true);
      this.open();
    }
  },
  updateQty(key, quantity) {
    const qty = parseInt(quantity, 10);
    const idx = this.cartData.items.findIndex(i => i.key === key);
    let previousSnapshot = null;
    if (idx !== -1) {
      previousSnapshot = { ...this.cartData.items[idx] };
      if (qty <= 0) {
        this.cartData.items.splice(idx, 1);
      } else {
        const unitPrice = previousSnapshot.price;
        this.cartData.items[idx].quantity = qty;
        this.cartData.items[idx].final_line_price = qty * unitPrice;
      }
      this.recalculate();
      this.render();
    }
    if (window.Shopify && Shopify.routes) {
      fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(res => res.json())
      .then(cart => {
        this.cartData = cart;
        this.render();
      })
      .catch(() => {
        if (previousSnapshot && idx !== -1) {
          this.cartData.items.splice(idx, 0, previousSnapshot);
          this.recalculate();
          this.render();
        }
      });
    }
  },
  fetchShopifyCart() {
    fetch(`${Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {
        this.cartData = cart;
        this.render();
      });
  },
  recalculate() {
    let count = 0;
    let total = 0;
    this.cartData.items.forEach(i => {
      count += i.quantity;
      total += i.final_line_price;
    });
    this.cartData.item_count = count;
    this.cartData.total_price = total;
    this.render();
  },
  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const format = window.FrutexMoneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  },
  render() {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = this.cartData.item_count > 0 ? `(${this.cartData.item_count})` : '(0)';
    });
    const headerBadge = document.querySelector('.header-cart-badge');
    if (headerBadge) {
      headerBadge.textContent = this.cartData.item_count;
    }
    const shippingWrapper = document.querySelector('.free-shipping-bar-wrapper');
    if (shippingWrapper) {
      const threshold = parseInt(shippingWrapper.dataset.threshold, 10) || 5000;
      const total = this.cartData.total_price;
      const progress = Math.min(100, Math.round((total / threshold) * 100));
      const fill = shippingWrapper.querySelector('.shipping-progress-fill');
      const msg = shippingWrapper.querySelector('[data-shipping-msg]');
      if (fill) fill.style.width = `${progress}%`;
      if (msg) {
        if (total >= threshold) {
          msg.innerHTML = '✨ <strong>Complimentary Botanical Shipping Unlocked!</strong>';
        } else {
          const remaining = this.formatMoney(threshold - total);
          msg.innerHTML = `Add <strong>${remaining}</strong> more to unlock <strong>Free Express Shipping</strong>`;
        }
      }
    }
    const container = document.querySelector('[data-cart-items]');
    if (!container) return;
    if (this.cartData.items.length === 0) {
      container.innerHTML = `
        <div class="cart-drawer-empty">
          <div class="empty-cart-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent-gold)" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
          </div>
          <h4>Your cart is currently empty</h4>
          <p>Infuse your haircare ritual with the nourishing power of FRUTEX botanical blend.</p>
          <button type="button" class="btn btn-primary btn-sm" onclick="FrutexCart.close()">Shop FRUTEX Oil</button>
        </div>
      `;
      const footer = document.querySelector('.cart-drawer-footer');
      if (footer) footer.style.display = 'none';
    } else {
      let html = '';
      this.cartData.items.forEach(item => {
        const rawImage = item.image;
        let imageUrl = '';
        if (rawImage) {
          if (typeof rawImage === 'object' && rawImage.src) {
            imageUrl = rawImage.src;
          } else if (typeof rawImage === 'string' && (rawImage.startsWith('http') || rawImage.startsWith('//'))) {
            imageUrl = rawImage;
          }
        }
        if (imageUrl && imageUrl.startsWith('//')) {
          imageUrl = 'https:' + imageUrl;
        }
        if (imageUrl && imageUrl.includes('cdn.shopify.com') && !imageUrl.includes('width=')) {
          imageUrl += (imageUrl.includes('?') ? '&' : '?') + 'width=160';
        }
        const imageMarkup = imageUrl
          ? `<img src="${imageUrl}" alt="${item.title}" width="70" height="70" loading="lazy">`
          : `<div class="cart-item-img-placeholder" aria-hidden="true"></div>`;
        html += `
          <div class="cart-item-row" data-key="${item.key}">
            <div class="cart-item-img">
              ${imageMarkup}
            </div>
            <div class="cart-item-details">
              <span class="cart-item-title">${item.title}</span>
              <span class="cart-item-variant">${item.variant_title || '100ml'}</span>
              <div class="cart-item-price">${this.formatMoney(item.final_line_price)}</div>
              <div class="cart-item-actions">
                <div class="qty-selector qty-selector-compact">
                  <button type="button" class="qty-btn" onclick="FrutexCart.updateQty('${item.key}', ${item.quantity - 1})">-</button>
                  <input type="number" class="qty-input" value="${item.quantity}" readonly>
                  <button type="button" class="qty-btn" onclick="FrutexCart.updateQty('${item.key}', ${item.quantity + 1})">+</button>
                </div>
                <button type="button" class="cart-item-remove" onclick="FrutexCart.updateQty('${item.key}', 0)">Remove</button>
              </div>
            </div>
          </div>
        `;
      });
      container.innerHTML = html;
      const footer = document.querySelector('.cart-drawer-footer');
      if (footer) footer.style.display = 'block';
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) {
        subtotalEl.textContent = this.formatMoney(this.cartData.total_price);
      }
    }
  }
};
const FrutexProduct = {
  selectVariant(button, size, price) {
    const parent = button.closest('.variant-options-pills');
    if (parent) {
      parent.querySelectorAll('.variant-pill').forEach(pill => pill.classList.remove('active'));
    }
    button.classList.add('active');
    const label = document.querySelector('.variant-selected-value');
    if (label) {
      label.textContent = size === '100ml' ? '100ml / 3.4 fl oz (Standard Ritual)' : '200ml (Duo 2x100ml Ritual)';
    }
    const priceContainer = document.querySelector('.price-item--regular');
    if (priceContainer) {
      const amount = price.toFixed(2);
      const format = window.FrutexMoneyFormat || '${{amount}}';
      priceContainer.textContent = format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
  },
  updatePageVariant(size, price, variantId) {
    const choices = document.querySelectorAll('.variant-choice');
    choices.forEach(c => c.classList.remove('active'));
    const selectedChoice = document.querySelector(`input[value="${size}"]`);
    if (selectedChoice) {
      selectedChoice.closest('.variant-choice').classList.add('active');
    }
    const priceEl = document.querySelector('.product-page-price-box .price-item--regular');
    if (priceEl) priceEl.textContent = price;
    const stickyPrice = document.getElementById('StickyPriceDisplay');
    if (stickyPrice) stickyPrice.textContent = price;
    const formInput = document.querySelector('#MainProductForm input[name="id"]');
    if (formInput) formInput.value = variantId;
  },
  buyNow(btn, quantityOverride, discountCode) {
    const form = btn.closest('form') || document.getElementById('MainProductForm');
    if (!form) return;
    const variantId = form.querySelector('input[name="id"]').value;
    const qtyInput = form.querySelector('.qty-input, [data-qty-input]') || document.querySelector('.product-action-row .qty-input');
    const qty = quantityOverride || (qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1);
    const originalText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span>Processing...</span>';
    const goToCheckout = () => {
      const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      const checkoutUrl = discountCode
        ? `${root}checkout?discount=${encodeURIComponent(discountCode)}`
        : `${root}checkout`;
      window.location.href = checkoutUrl;
    };
    if (window.Shopify && Shopify.routes) {
      fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
      .then(res => {
        if (!res.ok) return res.json().then(err => { throw new Error(err.description || 'Could not add to cart'); });
        return res.json();
      })
      .then(goToCheckout)
      .catch(err => {
        btn.disabled = false;
        btn.innerHTML = originalText;
        alert(err.message || 'Something went wrong. Please try again.');
      });
    } else {
      goToCheckout();
    }
  },
  incrementQty(btn) {
    const selector = btn.closest('.qty-selector');
    const input = selector ? selector.querySelector('.qty-input') : null;
    if (!input) return;
    const current = parseInt(input.value, 10);
    input.value = (isNaN(current) ? 1 : current) + 1;
    this.updateLinePriceForQty(input.value);
  },
  decrementQty(btn) {
    const selector = btn.closest('.qty-selector');
    const input = selector ? selector.querySelector('.qty-input') : null;
    if (!input) return;
    const current = parseInt(input.value, 10);
    const safeCurrent = isNaN(current) ? 1 : current;
    if (safeCurrent > 1) {
      input.value = safeCurrent - 1;
      this.updateLinePriceForQty(input.value);
    }
  },
  updateLinePriceForQty(qty) {
    const priceEl = document.querySelector('.product-page-price-box .price-item--regular');
    if (!priceEl) return;
    const unitPrice = parseInt(priceEl.dataset.unitPrice, 10);
    if (isNaN(unitPrice)) return;
    const totalCents = unitPrice * parseInt(qty, 10);
    const amount = (totalCents / 100).toFixed(2);
    const format = window.FrutexMoneyFormat || '${{amount}}';
    priceEl.textContent = format.replace(/\{\{\s*amount\s*\}\}/, amount);
  },
  switchGallery(btn, imgSrc, isBanner) {
    document.querySelectorAll('.gallery-thumb-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const mainImg = document.getElementById('ProductMainImage');
    const mainView = document.getElementById('GalleryMainView');
    if (mainImg && imgSrc) {
      mainImg.src = imgSrc;
    }
    if (mainImg && mainView) {
      if (isBanner) {
        mainImg.classList.add('is-banner-img');
        mainView.classList.add('is-banner-view');
      } else {
        mainImg.classList.remove('is-banner-img');
        mainView.classList.remove('is-banner-view');
      }
    }
  },
  toggleTab(btn) {
    const item = btn.closest('.product-accordion-item');
    const body = item.querySelector('.product-accordion-body');
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      btn.setAttribute('aria-expanded', 'false');
      btn.querySelector('.tab-arrow').textContent = '+';
      body.style.maxHeight = null;
    } else {
      btn.setAttribute('aria-expanded', 'true');
      btn.querySelector('.tab-arrow').textContent = '−';
      body.style.maxHeight = body.scrollHeight + 30 + 'px';
    }
  }
};
document.addEventListener('DOMContentLoaded', () => {
  FrutexTheme.init();
  FrutexHeroSlider.init();
  FrutexProductCards.init();
  if (window.Shopify && Shopify.routes) {
    FrutexCart.fetchShopifyCart();
  } else {
    FrutexCart.render();
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-action]');
    if (!btn) return;
    if (btn.dataset.qtyAction === 'increment') {
      FrutexProduct.incrementQty(btn);
    } else if (btn.dataset.qtyAction === 'decrement') {
      FrutexProduct.decrementQty(btn);
    }
  });
  const mainQtyInput = document.querySelector('.product-action-row .qty-input');
  if (mainQtyInput) {
    mainQtyInput.addEventListener('input', () => {
      const val = parseInt(mainQtyInput.value, 10);
      if (isNaN(val) || val < 1) return;
      FrutexProduct.updateLinePriceForQty(val);
    });
    mainQtyInput.addEventListener('blur', () => {
      const val = parseInt(mainQtyInput.value, 10);
      if (isNaN(val) || val < 1) {
        mainQtyInput.value = 1;
        FrutexProduct.updateLinePriceForQty(1);
      }
    });
  }
});
